// extracted by mini-css-extract-plugin
module.exports = {"root":"TooltipConfig_root__2Ew94","tooltipArea":"TooltipConfig_tooltipArea__1Yle5","tooltipEdit":"TooltipConfig_tooltipEdit__1hpnA"};